import { makeStyles } from '@material-ui/core/styles'
import transitions from '@material-ui/core/styles/transitions'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'initial !important',
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			overflow: 'hidden',
			[theme.breakpoints.up('sm')]: {
				marginLeft: theme.spacing(-3),
				marginRight: theme.spacing(-3),
			},
		},
		bgSection: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'flex-end',
			minHeight: theme.spacing(50),
			position: 'relative',

			[theme.breakpoints.only('sm')]: {
				marginLeft: theme.spacing(-3),
				marginRight: theme.spacing(-3),
			},
			[theme.breakpoints.only('xs')]: {
				marginLeft: theme.spacing(-2),
				marginRight: theme.spacing(-2),
			},
			[theme.breakpoints.up('md')]: {
				position: 'static',
				minHeight: 'auto !important',
			},
		},
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			height: '100%',
			[theme.breakpoints.up('md')]: {
				left: ({ direction }) => (direction === PageMetaData.ALIGNMENT.RIGHT ? '50%' : 0),
				right: ({ direction }) => (direction === PageMetaData.ALIGNMENT.RIGHT ? 0 : '50%'),
				transition: transitions.create(['left', 'right']),
			},
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: theme.palette.background.default,
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ opacity }) => opacity / 100,

				[theme.breakpoints.down('sm')]: {
					opacity: ({ mobileOpacity }) => mobileOpacity / 100,
				},
			},
		},
		title: {
			position: 'relative',
			zIndex: 1,
			marginBottom: theme.spacing(3),

			[theme.breakpoints.down('xs')]: {
				paddingLeft: theme.spacing(2),
				paddingRight: theme.spacing(2),
			},
		},
		grid: {
			[theme.breakpoints.up('md')]: {
				marginTop: 0,
			},
			[theme.breakpoints.down('sm')]: {
				marginTop: ({ mobileDirection }) =>
					mobileDirection === PageMetaData.ALIGNMENT.LEFT ? theme.spacing(4) : null,
				marginBottom: ({ mobileDirection }) =>
					mobileDirection === PageMetaData.ALIGNMENT.RIGHT ? theme.spacing(4) : null,
			},
		},
		content: {
			[theme.breakpoints.up('md')]: {
				paddingRight: ({ direction }) => (direction === PageMetaData.ALIGNMENT.RIGHT ? theme.spacing(3) : 0),
				paddingLeft: ({ direction }) => (direction === PageMetaData.ALIGNMENT.RIGHT ? 0 : theme.spacing(3)),
			},
		},
		textContainer: {},
		text: {},
	}),
	{ name: 'Content-Content1' },
)

export default useStyles
